<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">大型仪器设备使用情况</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model="formInline.serial_no" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="formInline.device_name" clearable placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="serial_no" fixed label="设备编号" width="120">
        </custom-table-column>
        <custom-table-column prop="device_name" fixed label="设备名称" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属组织结构" width="180">
          <template slot-scope="scope"  >
            <span>{{ scope.row.structure_1 }}{{ scope.row.structure_2 }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="person" label="负责人" width="100px">
        </custom-table-column>
        <custom-table-column prop="teaching_hours" label="使用机时（教学）" width="100px">
        </custom-table-column>
        <custom-table-column prop="research_hours" label="使用机时（科研）" width="100px">
        </custom-table-column>
        <custom-table-column prop="service_hours" label="使用机时（社会服务）" width="100px">
        </custom-table-column>
        <custom-table-column prop="open_hours" label="使用机时（开放使用机时）" width="100px">
        </custom-table-column>
        <custom-table-column prop="sample_count" label="测样数" width="100px">
        </custom-table-column>
        <custom-table-column prop="student_training_count" label="培训人员数（学生）" width="100px">
        </custom-table-column>
        <custom-table-column prop="teacher_training_count" label="培训人员数（教师）" width="100px">
        </custom-table-column>
        <custom-table-column prop="other_training_count" label="培训人员数（其他）" width="100px">
        </custom-table-column>
        <custom-table-column prop="teaching_project_count" label="教学实验项目数" width="100px">
        </custom-table-column>
        <custom-table-column prop="research_project_count" label="科研项目数" width="100px">
        </custom-table-column>
        <custom-table-column prop="service_project_count" label="社会服务项目数" width="100px">
        </custom-table-column>
        <custom-table-column prop="national_awards" label="获奖数（国家级）" width="100px">
        </custom-table-column>
        <custom-table-column prop="provincial_awards" label="获奖数（省部级）" width="100px">
        </custom-table-column>
        <custom-table-column prop="teacher_patents" label="发明专利数（教师）" width="100px">
        </custom-table-column>
        <custom-table-column prop="student_patents" label="发明专利数（学生）" width="100px">
        </custom-table-column>
        <custom-table-column prop="three_index_papers" label="发表论文数（三大检索）" width="100px">
        </custom-table-column>
        <custom-table-column prop="core_journal_papers" label="发表论文数（核心刊物）" width="100px">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEditNew(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="906px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
        <el-form-item label="使用的仪器设备" prop="new_device_individual_id">
          <el-cascader  v-model="ruleForm.new_device_individual_id" filterable ref="cascader" :props="props"
            style="width:632px;" clearable :options="eqs"></el-cascader>
        </el-form-item>
        <el-form-item label="负责人" prop="person">
          <el-input v-model="ruleForm.person" placeholder="请输入"  style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="使用机时（教学）" prop="teaching_hours">
          <el-input  type="number" v-model.number="ruleForm.teaching_hours" placeholder="请输入"  style="width:196px;"></el-input> 时 
        </el-form-item>
        <el-form-item label="使用机时（科研）" prop="research_hours">
          <el-input  type="number" v-model.number="ruleForm.research_hours" placeholder="请输入" style="width:196px;"></el-input> 时 
        </el-form-item>
        <el-form-item label="使用机时（社会服务）" prop="service_hours">
          <el-input  type="number" v-model.number="ruleForm.service_hours" placeholder="请输入" style="width:196px;"></el-input> 时 
        </el-form-item>
        <el-form-item label="使用机时（开放使用机时）" prop="open_hours">
          <el-input  type="number" v-model.number="ruleForm.open_hours" placeholder="请输入" style="width:196px;"></el-input> 时 
        </el-form-item>
        <el-form-item label="测样数" prop="sample_count">
          <el-input  type="number" v-model.number="ruleForm.sample_count" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="培训人员数（学生）" prop="student_training_count">
          <el-input  type="number" v-model.number="ruleForm.student_training_count" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="培训人员数（教师）" prop="teacher_training_count">
          <el-input  type="number" v-model.number="ruleForm.teacher_training_count" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="培训人员数（其他）" prop="other_training_count">
          <el-input  type="number" v-model.number="ruleForm.other_training_count" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="教学实验项目数" prop="teaching_project_count">
          <el-input  type="number" v-model.number="ruleForm.teaching_project_count" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="科研项目数" prop="research_project_count">
          <el-input  type="number" v-model.number="ruleForm.research_project_count" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="社会服务项目数" prop="service_project_count">
          <el-input  type="number" v-model.number="ruleForm.service_project_count" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="获奖数（国家级）" prop="national_awards">
          <el-input  type="number" v-model.number="ruleForm.national_awards" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="获奖数（省部级）" prop="provincial_awards">
          <el-input  type="number" v-model.number="ruleForm.provincial_awards" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="发明专利数（教师）" prop="teacher_patents">
          <el-input  type="number" v-model.number="ruleForm.teacher_patents" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="发明专利数（学生）" prop="student_patents">
          <el-input  type="number" v-model.number="ruleForm.student_patents" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="发表论文数（三大检索）" prop="three_index_papers">
          <el-input  type="number" v-model.number="ruleForm.three_index_papers" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="发表论文数（核心刊物）" prop="core_journal_papers">
          <el-input type="number" v-model.number="ruleForm.core_journal_papers" placeholder="请输入" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate, mixinOrgan, mixinFormatter],
  data() {
    return {
      formInline: {
        structure_1: '',
        structure_2: '',
        serial_no: '',
        device_name: '',
      },
      props: {
        emitPath: false
      },
      ruleForm: {
        new_device_individual_id:'',
        teaching_hours: 0,
        research_hours: 0,
        service_hours: 0,
        open_hours: 0,
        sample_count: 0,
        student_training_count: 0,
        teacher_training_count: 0,
        other_training_count: 0,
        teaching_project_count: 0,
        research_project_count: 0,
        service_project_count: 0,
        national_awards: 0,
        provincial_awards: 0,
        teacher_patents: 0,
        student_patents: 0,
        three_index_papers: 0,
        core_journal_papers: 0,
      },
      remainder_quantity: 0,
      eqs: [],
      rules: {
        new_device_individual_id: [{ required: true, message: '请选择', trigger: 'change' }],
        person: [{ required: true, message: '请输入', trigger: 'blur' }],
        teaching_hours: [{ required: true, message: '请输入', trigger: 'blur' }],
        research_hours: [{ required: true, message: '请输入', trigger: 'blur' }],
        service_hours: [{ required: true, message: '请输入', trigger: 'blur' }],
        open_hours: [{ required: true, message: '请输入', trigger: 'blur' }],
        sample_count: [{ required: true, message: '请输入', trigger: 'blur' }],
        student_training_count: [{ required: true, message: '请输入', trigger: 'blur' }],
        teacher_training_count: [{ required: true, message: '请输入', trigger: 'blur' }],
        other_training_count: [{ required: true, message: '请输入', trigger: 'blur' }],
        teaching_project_count: [{ required: true, message: '请输入', trigger: 'blur' }],
        research_project_count: [{ required: true, message: '请输入', trigger: 'blur' }],
        service_project_count: [{ required: true, message: '请输入', trigger: 'blur' }],
        national_awards: [{ required: true, message: '请输入', trigger: 'blur' }],
        provincial_awards: [{ required: true, message: '请输入', trigger: 'blur' }],
        teacher_patents: [{ required: true, message: '请输入', trigger: 'blur' }],
        student_patents: [{ required: true, message: '请输入', trigger: 'blur' }],
        three_index_papers: [{ required: true, message: '请输入', trigger: 'blur' }],
        core_journal_papers: [{ required: true, message: '请输入', trigger: 'blur' }],
        // teaching_hours: [
        //   { required: true, message: '维修价格不能为空', trigger: 'blur' },
        //   { validator: this.checkfloat, trigger: 'blur' },
        // ],
      },
    };
  },
  components: {},
  created() {
    this.initEqs();
  },
  mounted() {
  },
  methods: {
    async initEqs() {
      await this.$store.dispatch('getEqs',{is_big_device:1})
      this.eqs = this.$store.state.allEqs.map(item => {
        let children = []
        if (item.individuals && item.individuals.length > 0) {
          children = item.individuals.map(child => {
            return {
              value: child.id,
              label: child.serial_no
            }
          })
        }
        return {
          value: item.id,
          label: item.device_name,
          children
        }
      })
    },
    async deleteMethod() {
      let res = await this.$api.instance.interfaceServer(`api/big/device/usage/destroy/${this.delid}`, 'delete');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/big/device/usage/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/big/device/usage/store', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      let res = await this.$api.instance.interfaceServer(`api/big/device/usage/update/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      this.beforeQueryByKey("structure_1", "structure_2")
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
